import {extend} from "flarum/common/extend";
import HeaderSecondary from "flarum/forum/components/HeaderSecondary";
/*import Search from "flarum/forum/components/Search";
import ZSPlayersSearchSource from "../components/ZS/ZSPlayersSearchSource";
import SCPPlayersSearchSource from "../components/SCP/SCPPlayersSearchSource";*/

export default function() {
  extend(HeaderSecondary.prototype, "items", function(items) {
    items.remove("signUp");
  });
  /*extend(Search.prototype, "sourceItems", function(items) {
    items.add("zs_players", new ZSPlayersSearchSource());
    items.add("scp_players", new SCPPlayersSearchSource());
  });*/
}
